import Vue from 'vue';

/* Global EventBus to help modules communicate between themselves */
const EventBus = new Vue();

export default EventBus;
